import React, { useState } from "react";
import ErrorHelper from "../../../helper/error-helper";
import { NotificationManager } from "src/util/notify";
import InputKendoRct from "../../../control-components/input/input";
import Loader from "../../../control-components/loader/loader";
import { Dialog } from "@progress/kendo-react-dialogs";
import { ColorPicker } from "@progress/kendo-react-inputs";
import Utils from "../../../helper/utils"
import { Error } from '@progress/kendo-react-labels';
import { fileDocumentService } from "../../../services/fileDocumentTemplateService";

const AddEditDocumentTemplateTags = ({ onClose, selectedTag, getDocumentTemplateTags }) => {
    const paletteSettings = {
        palette: ["#28a745", "#dc3545", "#ffc107", "#007bff", "#6f42c1", "#f0d0c9", "#e2a293", "#d4735e", "#65281a", "#eddfda", "#dcc0b6", "#cba092", "#7b4b3a", "#fcecd5", "#f9d9ab", "#f6c781", "#c87d0e", "#e1dca5", "#d0c974", "#a29a36", "#514d1b", "#c6d9f0", "#8db3e2", "#548dd4", "#17365d"],
        columns: 5,
        tileSize: 30,
    };

    let [tagColor, setTagColor] = useState(selectedTag?.labelColor);
    const [errors, setErrors] = useState("");
    const [loading, setLoading] = useState(false);
    const [settingError, setSettingError] = useState(false);
    const [fields, setFields] = useState({
        labelName: selectedTag?.labelName,
        id: selectedTag?.id
    });

    const editDocumentTemplateTags = async () => {
        setLoading(true)
        await fileDocumentService.editDocumentTemplateTags(fields, tagColor, selectedTag)
            .then(result => {
                setLoading(false)
                NotificationManager.success("Update Document Template Label Successfully");
                onClose({ "updated": true });
                getDocumentTemplateTags()

            }).catch(error => {
                setLoading(false)
                NotificationManager.error(error);
            });
    }

    const addDocumentTemplateTags = async () => {
        setLoading(true)
        await fileDocumentService.addDocumentTemplateTags(fields, tagColor)
            .then(result => {
                setLoading(false)
                NotificationManager.success("Add Document Template Label Successfully");
                onClose({ "updated": true });
                getDocumentTemplateTags()
            }).catch(error => {
                setLoading(false)
                NotificationManager.error(error);
            });
    }

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        if (!fields.labelName || fields.labelName.trim().length === 0) {
            formIsValid = false;
            errors["labelName"] = ErrorHelper.LABEL;
        }
        // if (!tagColor || tagColor.trim().length === 0) {
        //     formIsValid = false;
        //     errors["tagColor"] = ErrorHelper.TAG_COLOR;
        // }
        setErrors(errors);
        return formIsValid;
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFields({
            ...fields,
            [name]: value,
        });
    };


    const handleSubmit = (event) => {
        setSettingError(true);
        if (handleValidation()) {
            if (selectedTag) {
                editDocumentTemplateTags();
            } else {
                addDocumentTemplateTags();
            }
        }
    };
    return (
        <Dialog
            onClose={onClose}
            title={selectedTag ? "Update Label" : "Add Label"}
            className="small-dailog "  width={"40%"} height={"42%"}
        >
            <div className=" edit-Service-popup py-3">
                <div className="mx-3">
                    <div className="row align-items-center">
                        <div className="k col-lg-10 col-md-10 col-12">
                            <InputKendoRct
                                value={fields.labelName}
                                onChange={handleChange}
                                name="labelName"
                                label="Label Name"
                                error={!fields.labelName && errors.labelName}
                                validityStyles={settingError}
                                required={true}
                                placeholder={"Label Name"}
                            />
                        </div>
                        <div className="col-lg-2 col-md-2 col-12 pt-4 brushArrow">
                            <ColorPicker
                                view="palette"
                                paletteSettings={paletteSettings}
                                defaultValue={tagColor}
                                value={tagColor}
                                onChange={(e) => {
                                    let newColor = Utils.rgba2hex(e.value, true)
                                    setTagColor(newColor)
                                }}

                            />
                        </div>
                    </div>
                    {
                        errors &&
                        <Error >
                            {errors.tagColor}
                        </Error>
                    }
                </div>
                {loading === true && <Loader />}
            </div>
            <div className="preview-btn-bottom">
                <div className="border-bottom-line"></div>
                <div className="d-flex my-4">
                    <div className="right-sde ml-3">
                        <button
                            className="btn blue-primary text-white green-btn btn-space btn-primary "
                            onClick={handleSubmit}
                        >
                            {selectedTag ? "Update" : "Add"}
                        </button>
                    </div>
                    <div className="right-sde-grey">
                        <button
                            className="btn grey-secondary text-white btn-space mx-2"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>

        </Dialog>
    );
};
export default AddEditDocumentTemplateTags;
